import { useEffect, useRef, useState } from "react";
import { FiDownload, FiExternalLink } from "react-icons/fi";
import { Document, Page, pdfjs } from "react-pdf";

import { profile } from "../data/profile";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const RESUME_FILENAME = "Ravi_Kant_Sharma_CV.pdf";

const ResumePage = () => {
  const wrapRef = useRef(null);
  const [pageWidth, setPageWidth] = useState(720);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const update = () => {
      if (wrapRef.current) {
        setPageWidth(Math.min(wrapRef.current.clientWidth - 32, 820));
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <div className="page resume-page">
      <div className="page-head">
        <h1 className="page-title">
          Resume <span className="page-title-alt">/ CV</span>
        </h1>
        <div className="resume-actions">
          <a
            className="lc-btn lc-btn-primary"
            href={profile.resumePdf}
            download={RESUME_FILENAME}
          >
            <FiDownload /> Download CV
          </a>
          <a
            className="lc-btn lc-btn-outline"
            href={profile.resumePdf}
            target="_blank"
            rel="noreferrer"
          >
            <FiExternalLink /> Open in new tab
          </a>
        </div>
      </div>

      <div className="lc-card resume-viewer" ref={wrapRef}>
        <Document
          file={profile.resumePdf}
          onLoadSuccess={({ numPages: n }) => setNumPages(n)}
          loading={<div className="resume-status">Loading resume…</div>}
          error={
            <div className="resume-status">
              Couldn&apos;t load the preview.{" "}
              <a href={profile.resumePdf} download={RESUME_FILENAME}>
                Download the PDF instead
              </a>
              .
            </div>
          }
        >
          {Array.from({ length: numPages || 1 }, (_, i) => (
            <Page
              key={i}
              pageNumber={i + 1}
              width={pageWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              className="resume-page-canvas"
            />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default ResumePage;
